import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiAccordion = {
  styleOverrides: {
    root: {
      margin: 0,
      border: `1px solid var(--mui-palette-grey-300)`,
      '&:first-child': {
        borderRadius: '20px 20px 0 0',
      },
      '&:last-child': {
        borderRadius: '0 0 20px 20px',
      },
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&::before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 0,
      },
    },
  },
} satisfies Components<Theme>['MuiAccordion'];

export const MuiAccordionSummary = {
  styleOverrides: {
    root: {
      '&.Mui-expanded': {
        minHeight: '48px',
      },
    },
  },
} satisfies Components<Theme>['MuiAccordionSummary'];

export const MuiAccordionDetails = {
  styleOverrides: {
    root: {
      borderTop: '1px solid var(--mui-palette-grey-300)',
    },
  },
} satisfies Components<Theme>['MuiAccordionDetails'];
